<template>
  <v-container grid-list-md fluid>
    <v-layout row wrap>
      <!-- waiting queue -->
      <v-flex xs12>
        <div class="section-title di-flex justify-space-between align-center">
          <span>Waiting Queue</span>
          <div style="width: 50%;">
            <v-text-field
              v-debounce:500ms="getPrescriptions"
              prepend-inner-icon="mdi-magnify"
              label="Search"
              v-model="search"
              hide-details
              single-line
              outline
              class="rounded"
            >
              <v-tooltip top slot="append-outer">
                <v-icon
                  class="mx-2"
                  medium
                  slot="activator"
                  @click="$router.push('/pharmacy/new')"
                  color="secondary"
                >mdi-plus-circle</v-icon>

                <span>New Prescription</span>
              </v-tooltip>
            </v-text-field>
          </div>
          <!-- <v-btn @click="$router.push('/pharmacy/new')" small icon color="primary">
            <v-icon>mdi-plus</v-icon>
          </v-btn> -->
        </div>
        <v-data-table
          class="highlight-rows"
          item-key="id"
          :headers="w_headers"
          :items="waitingQueue"
          disable-initial-sort
          :total-items="active.meta.total"
          :pagination.sync="paidQueue_pagination"
          :rows-per-page-items="per_page"
        >
          <template slot="items" slot-scope="props">
            <tr @click="props.expanded = !props.expanded">
              <td>{{ props.item.patient ? props.item.patient.name : 'Pharmacy Sale'}}</td>
              <td>{{ props.item.created_at | moment('YYYY-MM-DD') }}</td>
              <td>
                <input type="number" v-model="props.item.adjustments" class="inline-input" />
              </td>
              <td>{{props.item.drugs.reduce((p, n) => p += n.price * n.quantity, 0)}}</td>
              <td>
                {{
                parseFloat(props.item.drugs.reduce((p, n) => p += n.price * n.quantity, 0))
                +
                parseFloat(props.item.adjustments)
                }}
              </td>
              <td>
                <v-tooltip top>
                  <v-icon slot="activator" @click="confirm(props.item)" color="primary">mdi-check</v-icon>
                  <span>Confirm</span>
                </v-tooltip>

                <v-tooltip top>
                  <v-icon slot="activator" @click="print(props.item)">mdi-printer</v-icon>
                  <span>Print</span>
                </v-tooltip>
              </td>
            </tr>
          </template>

          <template v-slot:expand="{item}">
            <v-data-table
              class="sub-table"
              item-key="id"
              :headers="drugHeaders"
              :items="item.drugs"
              disable-initial-sort
              hide-actions
            >
              <template slot="items" slot-scope="props">
                <td>
                  <span style="position: absolute; left: 56px;">
                    <v-icon @click="removeDrug(props.index, item.drugs)" color="error">mdi-close</v-icon>
                  </span>
                  {{ props.item.name }}
                </td>
                <td>
                  <input v-model="props.item.route" class="inline-input" />
                </td>
                <td>
                  <input v-model="props.item.duration" class="inline-input" />
                </td>
                <td>
                  <input v-model="props.item.usage" class="inline-input" />
                </td>
                <td>
                  <input v-model="props.item.type" class="inline-input" />
                </td>
                <td>
                  <input type="number" v-model="props.item.quantity" class="inline-input" />
                </td>
                <td>
                  <input type="number" v-model="props.item.price" class="inline-input" />
                </td>
                <td>{{ props.item.price * props.item.quantity}}</td>
              </template>
            </v-data-table>
          </template>
        </v-data-table>
      </v-flex>

      <!-- paid queue -->
      <v-flex xs12 mt-5>
        <div class="section-title">Payment Done</div>

        <v-data-table
          class="highlight-rows"
          item-key="id"
          :total-items="active.meta.total"
          :pagination.sync="paidQueue_pagination"
          :headers="p_headers"
          :items="paidQueue"
          disable-initial-sort
          :rows-per-page-items="per_page"

        >
          <template slot="items" slot-scope="{item, expanded}">
            <tr @click="expanded = !expanded">
              <td>{{ item.patient ? item.patient.name : 'Pharmacy Sale'}}</td>
              <td>{{ item.created_at | moment('YYYY-MM-DD') }}</td>
              <td>{{item.adjustments}}</td>
              <td>{{item.total}}</td>
              <td>
                <v-tooltip top>
                  <v-icon slot="activator" @click="done(item)" color="primary">mdi-check-all</v-icon>
                  <span>Done</span>
                </v-tooltip>

                <v-tooltip top>
                  <v-icon slot="activator" @click="print(item)">mdi-printer</v-icon>
                  <span>Print</span>
                </v-tooltip>
              </td>
            </tr>
          </template>

          <template v-slot:expand="{item}">
            <v-data-table
              class="sub-table"
              item-key="id"
              :headers="drugHeaders"
              :items="item.drugs"
              disable-initial-sort
              hide-actions
            >
              <template slot="items" slot-scope="{item}">
                <td>{{ item.name }}</td>
                <td>{{ item.route }}</td>
                <td>{{ item.duration }}</td>
                <td>{{ item.usage }}</td>
                <td>{{ item.type }}</td>
                <td>{{item.quantity}}</td>
                <td>{{item.price}}</td>
                <td>{{ item.price * item.quantity}}</td>
              </template>
            </v-data-table>
          </template>
        </v-data-table>
      </v-flex>

      <!-- history -->
      <v-flex xs12 mt-5>

        <div class="section-title di-flex align-center justify-space-between">
          <div class>History</div> 

          <div style="width: 50%;">
            <v-text-field
              v-debounce:500ms="getHistory"
              prepend-inner-icon="mdi-magnify"
              v-model="history_search"
              label="Search"
              hide-details
              single-line
              outline
              class="rounded"
            ></v-text-field>
          </div>
          </div>

        <v-data-table
          :total-items="history.meta.total"
          :pagination.sync="pagination"
          :headers="headers2"
          :items="history.data"
          disable-initial-sort
          :rows-per-page-items="per_page"
        >
          <template slot="items" slot-scope="{item}">
            <td>{{ item.patient ? item.patient.name : 'Pharmacy Sale' }}</td>
            <td>{{ item.created_at | moment('YYYY-MM-DD h:mm:ss A') }}</td>
            <td>{{ item.adjustments }}</td>
            <td>{{ item.total }}</td>
            <td class="text-capitalize" :class="item.status">{{ item.status }}</td>
            <td>
              <v-tooltip top>
                <v-icon slot="activator" @click="print(item)">mdi-printer</v-icon>
                <span>Print</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  middleware: "pharmacy",
  // layout: "single",
  data() {
    return {
      active: {
        data: [],
        meta: {},
        links: {}
      },
      history: {
        data: [],
        meta: {},
        links: {}
      },
      search:"",
      history_search:"",
      pagination: {descending: true},
      paidQueue_pagination: {descending: true},
      w_headers: [
        { text: "Patient Name", value: "updated_at" },
        { text: "Date", value: "created_at" },
        { text: "Adjustments", value: "adjustments" },
        { text: "Total (AFN)", value: "total" },
        { text: "Net Total (AFN)", value: "total" },
        { text: "", value: "name", sortable: false }
      ],

      headers2: [
        { text: "Patient Name", value: "updated_at" },
        { text: "Date", value: "created_at" },
        { text: "Adjustments", value: "adjustments" },
        { text: "Total (AFN)", value: "total" },
        { text: "Status", value: "status" },
        { text: "", value: "name", sortable: false }
      ],

      p_headers: [
        { text: "Patient Name", value: "updated_at" },
        { text: "Date", value: "created_at" },
        { text: "Adjustments", value: "adjustments" },
        { text: "Net Total (AFN)", value: "total" },
        { text: "", value: "name", sortable: false }
      ],

      drugHeaders: [
        { text: "Drug Name", value: "name", sortable: false },
        { text: "Route", value: "route", sortable: false },
        { text: "Duration", value: "duration", sortable: false },
        { text: "Usage", value: "usage", sortable: false },
        { text: "Type", value: "type", sortable: false },
        { text: "Quantity", value: "quantity", sortable: false },
        { text: "Price (AFN)", value: "price", sortable: false },
        { text: "Total (AFN)", value: "name", sortable: false }
      ]
    };
  },
  computed: {
    waitingQueue() {
      return this.active.data.filter(x => x.status === "pending");
    },

    paidQueue() {
      return this.active.data.filter(x => x.status === "paid");
    }
  },
  watch: {
    pagination: {
      handler() {
        this.getHistory();
      }
    },
    paidQueue_pagination: {
      handler() {
        this.getPrescriptions();
      }
    }
  },
  methods: {
    print(item) {
      this.$store.commit("doctors/setPrescription", item);
      this.$router.push("/print/prescription");
    },

    removeDrug(index, list) {
      list = list.splice(index, 1);
    },

    async getHistory(){
      const { sortBy, descending, page, rowsPerPage } = this.pagination;
      let query = `/api/prescriptions/history?
      rows_per_page=${rowsPerPage}
      &search=${encodeURIComponent(this.history_search)}
      &page=${page}`;

      if (sortBy) query = `${query}&sort_by=${sortBy}`;
      if (descending !== null) query = `${query}&desc=${descending ? 1 : 0}`;
      const { data } = await this.axios.get(query);
      if (data) this.history = data;

    },

    async getPrescriptions() {
       const { sortBy, descending, page, rowsPerPage } = this.paidQueue_pagination;
      let query = `/api/prescriptions?
      rows_per_page=${rowsPerPage}
      &search=${encodeURIComponent(this.search)}
      &page=${page}`;

      if (sortBy) query = `${query}&sort_by=${sortBy}`;
      if (descending !== null) query = `${query}&desc=${descending ? 1 : 0}`;
      const { data } = await this.axios.get(query);
      if (data) this.active = data;
    },

    confirm(prescription) {
      let sub_total = prescription.drugs.reduce(
        (p, n) => (p += n.price * n.quantity),
        0
      );

      let adjustments = prescription.adjustments;
      let total = parseFloat(sub_total) + parseFloat(adjustments);
      let drugs = prescription.drugs;

      this.$modal.show({
        mode: "confirm",
        message: `
        <strong> Please review the following and confirm: </strong> <br>
        Total: ${sub_total} <br>
        Adjustments: ${adjustments} <br>
        <strong>Net Total: ${total} </strong>       
        `,
        onConfirm: async () => {
          await this.axios.put(
            `/api/prescriptions/${prescription.id}/confirm`,
            { drugs, total, adjustments }
          );
          this.getPrescriptions();
          this.getHistory()
        }
      });
    },

    reject(prescription) {
      this.$modal.show({
        title: "Rejection",
        confirmBtn: {
          color: "error",
          text: "Yes Reject"
        },
        message: `Reject the prescription:  ${prescription.prescription_name}?`,
        onConfirm: async () => {
          await this.axios.put(
            `/api/lab_prescriptions/${prescription.id}/reject`
          );
          this.getPrescriptions();
          this.getHistory()
        }
      });
    },

    done(prescription) {
      this.$modal.show({
        title: "Done and Recieved",
        confirmBtn: {
          color: "primary",
          text: "Yes, Done"
        },
        message: `Make Done?`,
        onConfirm: async () => {
          await this.axios.put(`/api/prescriptions/${prescription.id}/done`);
          this.getPrescriptions();
          this.getHistory()
        }
      });
    },

    deletePrescription(prescription) {
      this.$modal.show({
        message: `Are you sure, you want to delete this prescription?`,
        mode: "delete",
        onConfirm: async () => {
          await this.axios.delete(`/api/prescriptions/${prescription.id}`);
          this.getPrescriptions();
          this.getHistory()
        }
      });
    }
  }
};
</script>

<style>
.sub-table table thead tr th,
.sub-table table tbody tr td {
  background-color: rgba(0, 0, 0, 0.05);
}

.parent-table {
  border: 1px solid rgba(0, 0, 0, 0.2);
}

.sub-table {
  border-left: 1px solid rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  border-top: 0;
  margin-bottom: 15px;
  margin-left: 64px;
}

.sub-table .v-table tbody td:not(.v-datatable__expand-col),
.sub-table .v-table thead th:not(.v-datatable__expand-col) {
  height: 30px;
}

.inline-input {
  padding: 0 5px;
  border: 1px solid grey;
  width: 80px;
}

.iit {
  width: 80px;
}
</style>